import { loadAnalytics, isAnalyticsLoaded, clearAnalyticsData } from "extra/analytics";
import { loadChatbot, isChatbotLoaded, clearChatbotData } from "extra/chatbot";

// Tools that store data on the user's device and therefore run only after consent given in the cookie banner

export const loadConsentTools = () => {
	loadAnalytics();
	loadChatbot();
}

export const areConsentToolsLoaded = () => isAnalyticsLoaded() || isChatbotLoaded();

export const clearConsentToolsData = () => {
	clearAnalyticsData();
	clearChatbotData();
}
